import { useIsReadOnlyMode } from "components/AnalysisRenderMode";

export default function ReadOnlyMode({ children }) {
    const isReadOnlyMode = useIsReadOnlyMode();

    if (!isReadOnlyMode) {
        return null;
    }

    return (
        <>
            {children}
        </>
    );
}